import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface CaseData {
  id: number;
  name: string;
  age: number;
  ageGroup: string;
  symptom: string;
  duration: string;
  beforeImage: string;
  afterImage: string;
  doctorComment: string;
}

const Cases = () => {
  const [selectedAge, setSelectedAge] = useState<string>('all');
  const [selectedSymptom, setSelectedSymptom] = useState<string>('all');
  const [flippedCard, setFlippedCard] = useState<number | null>(null);

  const cases: CaseData[] = [
    {
      id: 1,
      name: '小明',
      age: 8,
      ageGroup: '6-9',
      symptom: 'crowding',
      duration: '12个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20child%20age%208%20with%20crowded%20teeth%20smiling%20showing%20dental%20condition%20before%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case1before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20child%20age%208%20with%20perfectly%20aligned%20straight%20teeth%20smiling%20confidently%20after%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case1after&orientation=portrait',
      doctorComment: '患儿配合度高，按时佩戴硅胶矫治器，牙列拥挤问题得到完美解决，咬合关系良好。'
    },
    {
      id: 2,
      name: '小芳',
      age: 10,
      ageGroup: '10-12',
      symptom: 'overbite',
      duration: '15个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2010%20with%20deep%20overbite%20dental%20condition%20smiling%20showing%20teeth%20before%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20side%20profile%20view&width=400&height=500&seq=case2before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2010%20with%20corrected%20bite%20and%20beautiful%20smile%20after%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20side%20profile%20view&width=400&height=500&seq=case2after&orientation=portrait',
      doctorComment: '深覆合矫治效果显著，面型改善明显，家长非常满意治疗结果。'
    },
    {
      id: 3,
      name: '小杰',
      age: 7,
      ageGroup: '6-9',
      symptom: 'underbite',
      duration: '18个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20boy%20age%207%20with%20underbite%20anterior%20crossbite%20dental%20condition%20before%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case3before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20boy%20age%207%20with%20corrected%20bite%20and%20confident%20smile%20after%20successful%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case3after&orientation=portrait',
      doctorComment: '地包天早期干预效果理想，避免了后期复杂治疗，颌骨发育正常。'
    },
    {
      id: 4,
      name: '小雨',
      age: 11,
      ageGroup: '10-12',
      symptom: 'spacing',
      duration: '10个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2011%20with%20gaps%20between%20teeth%20spacing%20issues%20smiling%20before%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20close%20up%20smile&width=400&height=500&seq=case4before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2011%20with%20perfectly%20closed%20gaps%20beautiful%20aligned%20teeth%20after%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20close%20up%20smile&width=400&height=500&seq=case4after&orientation=portrait',
      doctorComment: '牙列稀疏问题快速解决，矫治周期短，患儿自信心大幅提升。'
    },
    {
      id: 5,
      name: '小宇',
      age: 9,
      ageGroup: '6-9',
      symptom: 'crowding',
      duration: '14个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20boy%20age%209%20with%20severe%20crowded%20overlapping%20teeth%20before%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case5before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20boy%20age%209%20with%20beautifully%20aligned%20straight%20teeth%20confident%20smile%20after%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20front%20view%20portrait&width=400&height=500&seq=case5after&orientation=portrait',
      doctorComment: '重度拥挤案例，通过精准的数字化方案设计，获得了优秀的矫治效果。'
    },
    {
      id: 6,
      name: '小欣',
      age: 12,
      ageGroup: '10-12',
      symptom: 'overbite',
      duration: '16个月',
      beforeImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2012%20with%20deep%20overbite%20protruding%20front%20teeth%20before%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20side%20profile%20view&width=400&height=500&seq=case6before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Asian%20girl%20age%2012%20with%20perfect%20bite%20alignment%20radiant%20smile%20after%20successful%20orthodontic%20treatment%2C%20clean%20white%20medical%20background%2C%20professional%20dental%20photography%2C%20natural%20lighting%2C%20side%20profile%20view&width=400&height=500&seq=case6after&orientation=portrait',
      doctorComment: '深覆盖矫治成功，前牙内收效果明显，侧貌改善显著。'
    }
  ];

  const ageGroups = [
    { value: 'all', label: '全部年龄' },
    { value: '6-9', label: '6-9岁' },
    { value: '10-12', label: '10-12岁' }
  ];

  const symptoms = [
    { value: 'all', label: '全部症状' },
    { value: 'crowding', label: '牙列拥挤' },
    { value: 'spacing', label: '牙列稀疏' },
    { value: 'overbite', label: '深覆合' },
    { value: 'underbite', label: '地包天' }
  ];

  const getSymptomLabel = (symptom: string) => {
    const found = symptoms.find(s => s.value === symptom);
    return found ? found.label : symptom;
  };

  const filteredCases = cases.filter(c => {
    const ageMatch = selectedAge === 'all' || c.ageGroup === selectedAge;
    const symptomMatch = selectedSymptom === 'all' || c.symptom === selectedSymptom;
    return ageMatch && symptomMatch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            成功案例
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            见证每一个孩子的蜕变时刻，用专业与科技守护灿烂笑容
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="pb-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="flex flex-wrap gap-6 items-center justify-center">
              <div className="flex items-center gap-3">
                <i className="ri-user-line text-2xl text-blue-600"></i>
                <span className="text-gray-700 font-medium">年龄段：</span>
                <div className="flex gap-2">
                  {ageGroups.map(group => (
                    <button
                      key={group.value}
                      onClick={() => setSelectedAge(group.value)}
                      className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                        selectedAge === group.value
                          ? 'bg-blue-600 text-white shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {group.label}
                    </button>
                  ))}
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <i className="ri-stethoscope-line text-2xl text-orange-500"></i>
                <span className="text-gray-700 font-medium">症状类型：</span>
                <div className="flex gap-2">
                  {symptoms.map(symptom => (
                    <button
                      key={symptom.value}
                      onClick={() => setSelectedSymptom(symptom.value)}
                      className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                        selectedSymptom === symptom.value
                          ? 'bg-orange-500 text-white shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {symptom.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCases.map(caseItem => (
              <div
                key={caseItem.id}
                className="relative h-[600px] cursor-pointer"
                style={{ perspective: '1000px' }}
                onMouseEnter={() => setFlippedCard(caseItem.id)}
                onMouseLeave={() => setFlippedCard(null)}
              >
                <div
                  className={`relative w-full h-full transition-transform duration-700`}
                  style={{
                    transformStyle: 'preserve-3d',
                    transform: flippedCard === caseItem.id ? 'rotateY(180deg)' : 'rotateY(0deg)'
                  }}
                >
                  {/* Front Side */}
                  <div
                    className="absolute w-full h-full bg-white rounded-2xl shadow-xl overflow-hidden"
                    style={{ backfaceVisibility: 'hidden' }}
                  >
                    <div className="relative h-[400px] overflow-hidden">
                      <img
                        src={caseItem.beforeImage}
                        alt={`${caseItem.name}治疗前`}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute top-4 left-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold">
                        治疗前
                      </div>
                    </div>
                    <div className="p-6">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4">
                        {caseItem.name} · {caseItem.age}岁
                      </h3>
                      <div className="space-y-3">
                        <div className="flex items-center gap-3">
                          <i className="ri-heart-pulse-line text-xl text-orange-500 w-6 h-6 flex items-center justify-center"></i>
                          <span className="text-gray-700">
                            <strong>症状：</strong>{getSymptomLabel(caseItem.symptom)}
                          </span>
                        </div>
                        <div className="flex items-center gap-3">
                          <i className="ri-time-line text-xl text-blue-600 w-6 h-6 flex items-center justify-center"></i>
                          <span className="text-gray-700">
                            <strong>疗程：</strong>{caseItem.duration}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Back Side */}
                  <div
                    className="absolute w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl shadow-xl overflow-hidden"
                    style={{
                      backfaceVisibility: 'hidden',
                      transform: 'rotateY(180deg)'
                    }}
                  >
                    <div className="relative h-[400px] overflow-hidden">
                      <img
                        src={caseItem.afterImage}
                        alt={`${caseItem.name}治疗后`}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute top-4 left-4 bg-green-500 text-white px-4 py-2 rounded-full font-bold">
                        治疗后
                      </div>
                    </div>
                    <div className="p-6 text-white">
                      <h3 className="text-2xl font-bold mb-4 flex items-center gap-2">
                        <i className="ri-user-star-line text-yellow-300"></i>
                        医生点评
                      </h3>
                      <p className="text-white/90 leading-relaxed">
                        {caseItem.doctorComment}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredCases.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-xl text-gray-500">暂无符合条件的案例</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            您的孩子也能拥有自信笑容
          </h2>
          <p className="text-xl mb-8 text-white/90">
            立即预约专业医生，开启美丽蜕变之旅
          </p>
          <button className="bg-white text-blue-600 px-10 py-4 rounded-full text-lg font-bold hover:bg-blue-50 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap">
            寻找身边的医生
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Cases;
